// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.institution-detail-benchmarking {
  display: flex;
  flex-direction: column;
}
.institution-detail-benchmarking p {
  line-height: 20px !important;
}
.institution-detail-benchmarking .basic-information {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 30px;
}
.institution-detail-benchmarking .basic-information .bio-institution {
  width: 22%;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}
.institution-detail-benchmarking .basic-information .bio-institution .avatar {
  position: relative;
  margin-bottom: 20px;
}
.institution-detail-benchmarking .basic-information .bio-institution .avatar img {
  width: 98%;
  object-fit: cover;
}
.institution-detail-benchmarking .basic-information .bio-institution .name {
  margin-top: 15px;
  font-size: 16px;
  font-weight: bold;
}
.institution-detail-benchmarking .basic-information .bio-institution .links {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: 10px;
}
.institution-detail-benchmarking .basic-information .bio-institution .description .line {
  padding: 10px 0 15px 0;
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid var(--light-grey);
  font-size: 12px;
}
.institution-detail-benchmarking .basic-information .bio-institution .description .line img {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}
.institution-detail-benchmarking .basic-information .bio-institution .description .description p {
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.institution-detail-benchmarking .basic-information .bio-institution .description .see-more {
  color: var(--blue);
  text-decoration: underline;
  cursor: pointer;
}
.institution-detail-benchmarking .basic-information .institution-detail-word-map {
  width: 75%;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
}
.institution-detail-benchmarking .academic-result {
  width: 100%;
}
.institution-detail-benchmarking .academic-result .departments {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.institution-detail-benchmarking .academic-result .departments .title-department {
  display: flex;
  align-items: flex-start;
}
.institution-detail-benchmarking .academic-result .departments .card-list {
  width: 100%;
  background: white;
  height: 100px;
}
.institution-detail-benchmarking .academic-result .departments .card-list .department {
  display: flex;
  padding: 10px 20px;
  height: 70px;
  border-radius: 10px;
  background: var(--benchmarking-hover);
  margin-right: 10px;
}
.institution-detail-benchmarking .academic-result .departments .card-list .department:hover {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;
}
.institution-detail-benchmarking .academic-result .basic-statistic-institution {
  margin-bottom: 20px;
}
.institution-detail-benchmarking .academic-result .basic-statistic-institution .base {
  display: flex;
  width: 100%;
  margin-top: 20px;
}
.institution-detail-benchmarking .academic-result .basic-statistic-institution .base .stat-card {
  padding: 5px 15px;
  border-radius: 10px;
  border: 1px solid var(--light-grey);
  margin-right: 10px;
  width: 190px;
}
.institution-detail-benchmarking .academic-result .basic-statistic-institution .base .stat-card:hover {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  border: 1px solid white;
}
.institution-detail-benchmarking .academic-result .basic-statistic-institution .stat-graph {
  display: flex;
  margin-top: 30px;
  justify-content: space-between;
  align-items: center;
}
.institution-detail-benchmarking .academic-result .basic-statistic-institution .stat-graph .chart-title {
  color: var(--dark-grey);
  font-weight: 600;
  margin-bottom: 10px !important;
}
.institution-detail-benchmarking .academic-result .basic-statistic-institution .stat-graph .citation-by-year {
  width: 60%;
}
.institution-detail-benchmarking .academic-result .basic-statistic-institution .stat-graph .advance-param {
  width: 40%;
}

.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: var(--blue) !important;
}
.ant-tabs-tab-active .ant-tabs-tab-btn:hover {
  color: var(--blue) !important;
}

.faculty-publications {
  display: flex;
  flex-direction: column;
}
.faculty-publications .publication {
  margin-bottom: 25px;
}
.faculty-publications .publication .coauthors {
  margin-bottom: 3px;
  color: var(--dark-grey);
}
.faculty-publications .publication .coauthors span {
  margin-right: 10px !important;
  font-style: italic;
}
.faculty-publications .publication .title {
  margin-bottom: 3px;
}
.faculty-publications .publication .title .paper-title {
  font-weight: bold;
  cursor: pointer;
}
.faculty-publications .publication .title .paper-title:hover {
  text-decoration: underline;
  color: var(--blue);
}
.faculty-publications .publication .title .venue {
  font-style: italic;
}

.faculty-experience .experience {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}
.faculty-experience .experience .photo {
  margin-right: 30px;
  width: 50px;
  height: 40px;
}
.faculty-experience .experience .photo img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.faculty-experience .experience .experience-info .inst-name {
  font-weight: bold;
}

.institution-scholars .scholar {
  display: flex;
  align-items: flex-start;
  margin-bottom: 25px;
}
.institution-scholars .scholar .avatar {
  width: 60px;
  height: 60px;
  position: relative;
  margin-right: 20px;
}
.institution-scholars .scholar .avatar .photo {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}
.institution-scholars .scholar .avatar .check {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: -5px;
}
.institution-scholars .scholar .info p {
  margin-bottom: 3px !important;
}
.institution-scholars .scholar .info .name {
  font-weight: bold;
  cursor: pointer;
}
.institution-scholars .scholar .info .name:hover {
  text-decoration: underline;
  color: var(--blue);
}
.institution-scholars .scholar .info .inst-name {
  color: var(--dark-grey);
  font-weight: 600;
}
.institution-scholars .scholar .info .position {
  color: var(--dark-grey);
  font-style: italic;
}
.institution-scholars .scholar .info .tags {
  margin-bottom: 5px;
}

.institution-peers .peer {
  display: flex;
  align-items: flex-start;
  margin-bottom: 25px;
}
.institution-peers .peer .avatar {
  width: 60px;
  height: 60px;
  position: relative;
  margin-right: 20px;
}
.institution-peers .peer .avatar .photo {
  width: 60px;
  height: 60px;
  border-radius: 10px;
}
.institution-peers .peer .avatar .check {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: -5px;
}
.institution-peers .peer .info p {
  margin-bottom: 3px !important;
}
.institution-peers .peer .info .name {
  font-weight: bold;
  cursor: pointer;
}
.institution-peers .peer .info .name:hover {
  text-decoration: underline;
  color: var(--blue);
}
.institution-peers .peer .info .desciption-peer {
  margin-bottom: 10px;
}
.institution-peers .peer .info .desciption-peer p {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/InstitutionDetail.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AAAE;EACE,4BAAA;AAEJ;AAAE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAEJ;AADI;EACE,UAAA;EACA,yCAAA;EAEA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AAEN;AADM;EACE,kBAAA;EACA,mBAAA;AAGR;AAFQ;EACE,UAAA;EACA,iBAAA;AAIV;AADM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAGR;AADM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;AAGR;AAAQ;EACE,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,0CAAA;EACA,eAAA;AAEV;AADU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAGZ;AACU;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AACZ;AAEQ;EACE,kBAAA;EACA,0BAAA;EACA,eAAA;AAAV;AAII;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;AAFN;AAME;EACE,WAAA;AAJJ;AAKI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAHN;AAIM;EACE,aAAA;EACA,uBAAA;AAFR;AAIM;EACE,WAAA;EACA,iBAAA;EACA,aAAA;AAFR;AAGQ;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;AADV;AAGQ;EACE,0CAAA;EACA,eAAA;AADV;AAKI;EACE,mBAAA;AAHN;AAIM;EACE,aAAA;EACA,WAAA;EACA,gBAAA;AAFR;AAGQ;EACE,iBAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,YAAA;AADV;AAGQ;EACE,0CAAA;EACA,uBAAA;AADV;AAIM;EACE,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;AAFR;AAGQ;EACE,uBAAA;EACA,gBAAA;EACA,8BAAA;AADV;AAGQ;EACE,UAAA;AADV;AAGQ;EACE,UAAA;AADV;;AAQE;EACE,6BAAA;AALJ;AAOE;EACE,6BAAA;AALJ;;AASA;EACE,aAAA;EACA,sBAAA;AANF;AAOE;EACE,mBAAA;AALJ;AAMI;EACE,kBAAA;EACA,uBAAA;AAJN;AAKM;EACE,6BAAA;EACA,kBAAA;AAHR;AAMI;EACE,kBAAA;AAJN;AAKM;EACE,iBAAA;EACA,eAAA;AAHR;AAKM;EACE,0BAAA;EACA,kBAAA;AAHR;AAKM;EACE,kBAAA;AAHR;;AASE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AANJ;AAOI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AALN;AAMM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAJR;AAQM;EACE,iBAAA;AANR;;AAaE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAVJ;AAWI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AATN;AAUM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AARR;AAUM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AARR;AAYM;EACE,6BAAA;AAVR;AAYM;EACE,iBAAA;EACA,eAAA;AAVR;AAYM;EACE,0BAAA;EACA,kBAAA;AAVR;AAYM;EACE,uBAAA;EACA,gBAAA;AAVR;AAYM;EACE,uBAAA;EACA,kBAAA;AAVR;AAYM;EACE,kBAAA;AAVR;;AAgBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAbJ;AAcI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAZN;AAaM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAXR;AAaM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AAXR;AAeM;EACE,6BAAA;AAbR;AAeM;EACE,iBAAA;EACA,eAAA;AAbR;AAeM;EACE,0BAAA;EACA,kBAAA;AAbR;AAeM;EACE,mBAAA;AAbR;AAcQ;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAZV","sourcesContent":[".institution-detail-benchmarking {\n  display: flex;\n  flex-direction: column;\n  p {\n    line-height: 20px !important;\n  }\n  .basic-information {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 30px;\n    .bio-institution {\n      width: 22%;\n      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n\n      border-radius: 10px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      padding: 20px;\n      .avatar {\n        position: relative;\n        margin-bottom: 20px;\n        img {\n          width: 98%;\n          object-fit: cover;\n        }\n      }\n      .name {\n        margin-top: 15px;\n        font-size: 16px;\n        font-weight: bold;\n      }\n      .links {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        padding-bottom: 10px;\n      }\n      .description {\n        .line {\n          padding: 10px 0 15px 0;\n          display: flex;\n          align-items: flex-start;\n          border-bottom: 1px solid var(--light-grey);\n          font-size: 12px;\n          img {\n            width: 25px;\n            height: 25px;\n            margin-right: 10px;\n          }\n        }\n        .description {\n          p {\n            display: -webkit-box;\n            -webkit-line-clamp: 6;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n          }\n        }\n        .see-more {\n          color: var(--blue);\n          text-decoration: underline;\n          cursor: pointer;\n        }\n      }\n    }\n    .institution-detail-word-map {\n      width: 75%;\n      padding: 25px;\n      border-radius: 10px;\n      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n    }\n  }\n\n  .academic-result {\n    width: 100%;\n    .departments {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      margin-bottom: 20px;\n      .title-department {\n        display: flex;\n        align-items: flex-start;\n      }\n      .card-list {\n        width: 100%;\n        background: white;\n        height: 100px;\n        .department {\n          display: flex;\n          padding: 10px 20px;\n          height: 70px;\n          border-radius: 10px;\n          background: var(--benchmarking-hover);\n          margin-right: 10px;\n        }\n        .department:hover {\n          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n          cursor: pointer;\n        }\n      }\n    }\n    .basic-statistic-institution {\n      margin-bottom: 20px;\n      .base {\n        display: flex;\n        width: 100%;\n        margin-top: 20px;\n        .stat-card {\n          padding: 5px 15px;\n          border-radius: 10px;\n          border: 1px solid var(--light-grey);\n          margin-right: 10px;\n          width: 190px;\n        }\n        .stat-card:hover {\n          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n          border: 1px solid white;\n        }\n      }\n      .stat-graph {\n        display: flex;\n        margin-top: 30px;\n        justify-content: space-between;\n        align-items: center;\n        .chart-title {\n          color: var(--dark-grey);\n          font-weight: 600;\n          margin-bottom: 10px !important;\n        }\n        .citation-by-year {\n          width: 60%;\n        }\n        .advance-param {\n          width: 40%;\n        }\n      }\n    }\n  }\n}\n.ant-tabs-tab-active {\n  .ant-tabs-tab-btn {\n    color: var(--blue) !important;\n  }\n  .ant-tabs-tab-btn:hover {\n    color: var(--blue) !important;\n  }\n}\n\n.faculty-publications {\n  display: flex;\n  flex-direction: column;\n  .publication {\n    margin-bottom: 25px;\n    .coauthors {\n      margin-bottom: 3px;\n      color: var(--dark-grey);\n      span {\n        margin-right: 10px !important;\n        font-style: italic;\n      }\n    }\n    .title {\n      margin-bottom: 3px;\n      .paper-title {\n        font-weight: bold;\n        cursor: pointer;\n      }\n      .paper-title:hover {\n        text-decoration: underline;\n        color: var(--blue);\n      }\n      .venue {\n        font-style: italic;\n      }\n    }\n  }\n}\n.faculty-experience {\n  .experience {\n    display: flex;\n    align-items: center;\n    margin-bottom: 25px;\n    .photo {\n      margin-right: 30px;\n      width: 50px;\n      height: 40px;\n      img {\n        width: 100%;\n        height: 100%;\n        border-radius: 10px;\n      }\n    }\n    .experience-info {\n      .inst-name {\n        font-weight: bold;\n      }\n    }\n  }\n}\n\n.institution-scholars {\n  .scholar {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 25px;\n    .avatar {\n      width: 60px;\n      height: 60px;\n      position: relative;\n      margin-right: 20px;\n      .photo {\n        width: 60px;\n        height: 60px;\n        border-radius: 50%;\n        object-fit: cover;\n      }\n      .check {\n        position: absolute;\n        width: 20px;\n        height: 20px;\n        bottom: 0;\n        right: -5px;\n      }\n    }\n    .info {\n      p {\n        margin-bottom: 3px !important;\n      }\n      .name {\n        font-weight: bold;\n        cursor: pointer;\n      }\n      .name:hover {\n        text-decoration: underline;\n        color: var(--blue);\n      }\n      .inst-name {\n        color: var(--dark-grey);\n        font-weight: 600;\n      }\n      .position {\n        color: var(--dark-grey);\n        font-style: italic;\n      }\n      .tags {\n        margin-bottom: 5px;\n      }\n    }\n  }\n}\n.institution-peers {\n  .peer {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 25px;\n    .avatar {\n      width: 60px;\n      height: 60px;\n      position: relative;\n      margin-right: 20px;\n      .photo {\n        width: 60px;\n        height: 60px;\n        border-radius: 10px;\n      }\n      .check {\n        position: absolute;\n        width: 20px;\n        height: 20px;\n        bottom: 0;\n        right: -5px;\n      }\n    }\n    .info {\n      p {\n        margin-bottom: 3px !important;\n      }\n      .name {\n        font-weight: bold;\n        cursor: pointer;\n      }\n      .name:hover {\n        text-decoration: underline;\n        color: var(--blue);\n      }\n      .desciption-peer {\n        margin-bottom: 10px;\n        p {\n          display: -webkit-box;\n          -webkit-line-clamp: 3;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
